import request from '@/utils/request'

// 查询联盟申请列表
export function listUnionAffiliateApply(query) {
  return request({
    url: '/union/union/affiliate/apply/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询联盟申请分页
export function pageUnionAffiliateApply(query) {
  return request({
    url: '/union/union/affiliate/apply/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询联盟申请详细
export function getUnionAffiliateApply(data) {
  return request({
    url: '/union/union/affiliate/apply/detail',
    method: 'get',
    params: data
  })
}

// 新增联盟申请
export function addUnionAffiliateApply(data) {
  return request({
    url: '/union/union/affiliate/apply/add',
    method: 'post',
    data: data
  })
}

// 修改联盟申请
export function updateUnionAffiliateApply(data) {
  return request({
    url: '/union/union/affiliate/apply/edit',
    method: 'post',
    data: data
  })
}

// 删除联盟申请
export function delUnionAffiliateApply(data) {
  return request({
    url: '/union/union/affiliate/apply/delete',
    method: 'post',
    data: data
  })
}

// 批量通过联盟申请
export function batchPassUnionAffiliateApply(data) {
  return request({
    url: '/union/union/affiliate/apply/batchPass',
    method: 'post',
    data: data
  })
}

// 批量拒绝联盟申请
export function batchRejectUnionAffiliateApply(data) {
  return request({
    url: '/union/union/affiliate/apply/batchReject',
    method: 'post',
    data: data
  })
}
